import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { eventAlarmTypesState, loadedEventAlarmTypesState } from '../../../storage/gpt';

export function useGptEventAlarmTypes() {
  const alarmTypes = useRecoilValue(eventAlarmTypesState);
  const loadedAlarmTypes = useRecoilValue(loadedEventAlarmTypesState);

  const getAlarmTypeName = useCallback(
    (type: number) => {
      return alarmTypes?.find((t) => t.code === type)?.name ?? type.toString();
    },
    [alarmTypes],
  );

  const getAlarmColor = useCallback(
    (type: number) => {
      return alarmTypes?.find((t) => t.code === type)?.color ?? '#B00000';
    },
    [alarmTypes],
  );

  return {
    loadedAlarmTypes,
    getAlarmTypeName,
    getAlarmColor,
  };
}
